import React from 'react';
import { Box, Button, Flex, HStack, Text, Link } from '@chakra-ui/react';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { useAdmin } from './AdminGuard';
import { COLORS } from '../../../theme';

export default function AdminLayout() {
  const { user, signOut } = useAdmin();

  return (
    <Box>
      <Flex
        align="center"
        justify="space-between"
        p={4}
        bg="gray.800"
        boxShadow="md"
      >
        <HStack spacing={4}>
          <Box
            w={11}
            h={11}
            borderRadius="md"
            bg="white"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight="bold"
            color="gray.900"
            fontSize="lg"
          >
            {(user?.login || 'A').charAt(0).toUpperCase()}
          </Box>
          <Box>
            <Text fontWeight="bold" color="white" fontSize="md">
              {user?.login}
            </Text>

            <Link
              href="#"
              color={COLORS.brand.primary}
              onClick={signOut}
              fontSize="sm"
            >
              Sign out
            </Link>
          </Box>
        </HStack>

        <HStack spacing={2}>
          <Button
            as={RouterLink}
            to="/admin"
            variant="ghost"
            color="white"
            _hover={{ bg: 'gray.700' }}
          >
            Dashboard
          </Button>
          <Button
            as={RouterLink}
            to="/admin/manage-events"
            variant="ghost"
            color="white"
            _hover={{ bg: 'gray.700' }}
          >
            Events
          </Button>
          {/* <Button colorScheme="red" size="sm" onClick={signOut}>
            Sign out
          </Button> */}
        </HStack>
      </Flex>

      <Box p={6}>
        <Outlet />
      </Box>
    </Box>
  );
}
